import React from "react";
import "../styles/Ticker.css";

const Ticker = () => {
  return (
    <div className="ticker-container">
      <div className="ticker-text">Explore fascinating space data from NASA’s APIs.</div>
    </div>
  );
};

export default Ticker;
